import React from 'react'
import { Link } from 'gatsby'
import { useState } from 'react'

import BtnBurger from './../../atoms/btn-burger/btn-burger'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import './sub-layout.scss'
import getUserInfo from '../../../utils/getUserInfo'
import Show from '../../../utils/show'
import { jsonToHash } from '../../../utils/crypto'

const LOCALE =
  ['es-AR', 'es-CL', 'es-PE', 'es-UY', 'es-PY'].indexOf(process.env.LOCALE) > -1
    ? process.env.LOCALE
    : 'default'
const italatam = LOCALE === 'es-AR' || LOCALE === 'es-UY'

export default function SubLayout(props) {
  const { isMobile, children } = props
  const [isOpenMenu, setIsOpenMenu] = useState(false)
  const userInfo = getUserInfo()
  const handleClick = async label => {
    const user_data =
    userInfo !== null
      ? await jsonToHash([
          {
            nombre: userInfo.name,
            apellido: userInfo.lastName,
            celular: userInfo.cellPhone,
            correo: userInfo.email,
            ciudad: userInfo.location.cityName,
            departamento: userInfo.location.countryStateName,
            pais: userInfo.countryName,
          },
        ])
      : null
    pushEventData({
      event: 'Interacciones_Menú_VMatch',
      label,
      user_data,
      log_status: userInfo ? 'Yes' : 'Not',
    })
  }

  return (
    <div className="sub-layout">
      <div className="sub-layout-container">
        <div className={`nav-menu ${isMobile ? 'mobile' : 'desktop'}`}>
          {isMobile && (
            <BtnBurger
              isOpen={isOpenMenu}
              onClick={() => {
                setIsOpenMenu(!isOpenMenu)
              }}
            />
          )}
          <div
            className={`nav-menu-container ${isOpenMenu ? 'open' : 'close'}`}
          >
            <div className="menu-wrapper">
              <Show valid={!italatam && LOCALE != 'es-PY'}>
                <Link
                  to={'/'}
                  activeClassName="active"
                  onClick={() => handleClick('inicio')}
                >
                  INICIO
                </Link>
                <Link
                  to={'/como-participo'}
                  activeClassName="active"
                  onClick={() => handleClick('como-participo')}
                >
                  ¿CÓMO PARTICIPO?
                </Link>
                <Link
                  to={'/juega'}
                  activeClassName="active"
                  onClick={() => handleClick('juega')}
                >
                  JUEGA
                </Link>
                <Link
                  to={'/top'}
                  activeClassName="active"
                  onClick={() => handleClick('top')}
                >
                  TOP
                </Link>
                <Link
                  className="tyc"
                  to={'/terminos'}
                  activeClassName="active"
                  onClick={() => handleClick('terminos-y-condiciones')}
                >
                  TÉRMINOS Y CONDICIONES
                </Link>
              </Show>
              <Show valid={LOCALE === 'es-PY'}>
                <Link
                  to={'/'}
                  activeClassName="active"
                  onClick={() => handleClick('inicio')}
                >
                  INICIO
                </Link>
                <Link
                  to={'/como-participo'}
                  activeClassName="active"
                  onClick={() => handleClick('como-participo')}
                >
                  ¿CÓMO PARTICIPO?
                </Link>
                <Link
                  to={'/juega'}
                  activeClassName="active"
                  onClick={() => handleClick('juega')}
                >
                  JUGÁ
                </Link>
                <Link
                  to={'/top'}
                  activeClassName="active"
                  onClick={() => handleClick('top')}
                >
                  TOP
                </Link>
                <Link
                  className="tyc"
                  to={'/terminos'}
                  activeClassName="active"
                  onClick={() => handleClick('terminos-y-condiciones')}
                >
                  TÉRMINOS Y CONDICIONES
                </Link>
              </Show>
              <Show valid={italatam}>
                <Link
                  to={'/'}
                  activeClassName="active"
                  onClick={() => handleClick('inicio')}
                >
                  INICIO
                </Link>
                <Link
                  to={'/como-participo'}
                  activeClassName="active"
                  onClick={() => handleClick('como-participo')}
                >
                  ¿CÓMO PARTICIPO?
                </Link>
                <Link
                  to={'/juega'}
                  activeClassName="active"
                  onClick={() => handleClick('juega')}
                >
                  JUGÁ
                </Link>
                <Link
                  className="tyc"
                  to={'/terminos'}
                  activeClassName="active"
                  onClick={() => handleClick('terminos-y-condiciones')}
                >
                  TÉRMINOS Y CONDICIONES
                </Link>
              </Show>
            </div>
          </div>
        </div>
        <div
          className={`sub-layout-container-body ${
            isOpenMenu ? 'open' : 'close'
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  )
}
